import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/feature/BackToTop';
import ContributeCta from '@/components/feature/ContributeCta';
import { useSeo, siteOrigin } from '@/hooks/useSeo';
import { faqs } from '@/mocks/faq';
import HeroSection from './components/HeroSection';
import NavOverview from './components/NavOverview';
import FeaturedSection from './components/FeaturedSection';
import TopicsSection from './components/TopicsSection';
import SectionsSection from './components/SectionsSection';
import StatsSection from './components/StatsSection';
import FaqSection from './components/FaqSection';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '爆料官网',
      url: siteOrigin,
      email: 'editor@baoliao-gw.com',
      description: '以栏目介绍、频道列表、专题分类与内容板块为核心的爆料资讯门户。',
    },
    {
      '@type': 'WebSite',
      name: '爆料官网',
      url: siteOrigin,
      inLanguage: 'zh-CN',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${siteOrigin}/channels`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      name: '爆料官网 | 栏目介绍 · 频道列表 · 专题分类与内容板块导航',
      url: siteOrigin,
      description:
        '爆料官网栏目介绍与频道列表，详解专题分类和内容板块，清晰展示导航栏结构，帮助你快速定位感兴趣的爆料领域。',
      isPartOf: { '@type': 'WebSite', url: siteOrigin },
    },
    {
      '@type': 'FAQPage',
      mainEntity: faqs.map((item) => ({
        '@type': 'Question',
        name: item.q,
        acceptedAnswer: { '@type': 'Answer', text: item.a },
      })),
    },
  ],
};

export default function Home() {
  useSeo({
    title: '爆料官网 | 栏目介绍 · 频道列表 · 专题分类与内容板块导航',
    description:
      '爆料官网栏目介绍与频道列表，详解专题分类和内容板块，清晰展示导航栏结构，帮助你快速定位感兴趣的爆料领域，高效浏览全站内容。',
    keywords: '爆料官网,栏目介绍,频道列表,专题分类,内容板块,导航栏',
    path: '/',
    jsonLd: homeJsonLd,
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <NavOverview />
        <FeaturedSection />
        <TopicsSection />
        <SectionsSection />
        <StatsSection />
        <FaqSection />
        <ContributeCta />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}